import { AttributesSelector, Box, Flex, Text, Input } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { FormProvider, useFormContext, Path, PathValue } from 'react-hook-form'

export interface IntFilterProps<FilterSchema extends Record<string, any>> {
  fieldPath: Path<FilterSchema>
  label: string
  filterKey: string
  inputLabel?: string
  formatValue?: (value: number | null) => string
}

export const IntFilter = <FilterSchema extends Record<string, any>>({
  fieldPath,
  label,
  filterKey,
  inputLabel,
  formatValue = (value) => (value !== null ? `${value}` : ''),
}: IntFilterProps<FilterSchema>) => {
  const methods = useFormContext<FilterSchema>()

  const value = methods.watch(fieldPath) as number | null

  const resetToDefaultValues = () => {
    methods.setValue(
      fieldPath,
      null as PathValue<FilterSchema, Path<FilterSchema>>
    )
  }

  const selectedAttributes = useMemo(() => {
    const attributes: string[] = []

    if (value !== null && value !== undefined) {
      const formatted = formatValue(value)
      if (formatted) {
        attributes.push(formatted)
      }
    }

    return attributes
  }, [value, formatValue])

  return (
    <FormProvider {...methods}>
      <AttributesSelector
        label={label}
        rootGroupTitle="Filter by"
        selectedAttributes={selectedAttributes}
        onClearAll={resetToDefaultValues}
        groups={
          <AttributesSelector.Group
            key={filterKey}
            title={label}
            numberOfSelectedAttributes={selectedAttributes.length}
          >
            <Box>
              <Flex flexDirection="column" gap={2}>
                <Box>
                  {label ? (
                    <Text fontSize="sm" fontWeight="medium" mb={1}>
                      {label}
                    </Text>
                  ) : null}
                  <Input
                    type="number"
                    placeholder={'Enter ' + inputLabel}
                    value={methods.watch(fieldPath) || ''}
                    onChange={(e) => {
                      const value = e.target.value
                      methods.setValue(
                        fieldPath,
                        (value ? parseInt(value, 10) : null) as PathValue<
                          FilterSchema,
                          Path<FilterSchema>
                        >
                      )
                    }}
                  />
                </Box>
              </Flex>
            </Box>
          </AttributesSelector.Group>
        }
      />
    </FormProvider>
  )
}
